import CreateLeadForm from '@/components/features/Leads/forms/CreateLeadForm';
import { useTranslations } from '@/hooks/useTranslations';
import CreateLayout from '@/layouts/create-layout';
import { Company, People, PriorityOption, StatusOption, User, type BreadcrumbItem } from '@/types';
import { Head } from '@inertiajs/react';

interface CreateLeadPageProps {
    companies: Company[];
    people: People[];
    users: User[];
    priorities: PriorityOption[];
    statuses: StatusOption[];
    currentUser: User;
}

export default function CreateLead({ people, users, currentUser }: CreateLeadPageProps) {
    const { t } = useTranslations();

    const breadcrumbs: BreadcrumbItem[] = [
        {
            title: t('dashboard.breadcrumbs.dashboard', 'Dashboard'),
            href: '/dashboard',
        },
        {
            title: t('leads.index.breadcrumbs.leads', 'Leads'),
            href: '/leads',
        },
        {
            title: t('leads.create.breadcrumbs.create', 'Create'),
            href: '/leads/create',
        },
    ];

    return (
        <CreateLayout
            breadcrumbs={breadcrumbs}
            title={t('leads.create.heading', 'Create Opportunity')}
            subtitle={t('leads.create.subheading', 'Add a new opportunity to your sales pipeline')}
        >
            <Head title={t('leads.create.title', 'Create Opportunity')} />
            <CreateLeadForm people={people} users={users} currentUser={currentUser} />
        </CreateLayout>
    );
}
